import dayjs from 'dayjs';
import shortUUID from 'short-uuid';

import { GLOBAL_DATE_FORMAT } from '../../constants';

export const mapCommunityLivingInfoToData = (item: any, communityId?: number) => {
  return {
    id: item?.id,
    key: item ? String(item?.id) : shortUUID.generate(),
    apartmentType: item?.apartment_type,
    apartmentTypeId: item?.apartment_type_id,
    apartmentTypeGroupId: item?.apartment_type_groups?.length ? item.apartment_type_groups[0].id : undefined,
    livingTypeId: item?.living_type_id,
    livingType: item?.living_type,
    baseRent: item?.base_rent,
    entranceFee: item?.entrance_fee,
    squareFootage: item?.sq_footage,
    pricePerSquare: item?.price_per_sq,
    notes: item?.notes,
    createdBy: item?.created_by,
    createdAt: dayjs(new Date(item?.created_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    updatedBy: item?.updated_by,
    updatedAt: dayjs(new Date(item?.updated_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    date: dayjs(new Date(item?.date).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    contracts: item.contracts,
    unitType: item?.unit_type,
    communityId,
  };
};
